import { Injectable } from '@angular/core';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private globalHelper:GlobalHelper, private httpclient: HttpClient) { }

  SaveSession(strdata: any): Observable<any> {
    let Parameter = 'objSession=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveSession?' + encodeURI(Parameter),
      { headers: reqHeader });
  }
  SetAcademicSession(strdata:any):Observable<any>{  
    let data='SessionItem=' +strdata;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Master/SetAcademicSession?'+encodeURI(data),{headers:reqHeader});
  }
  GetAllAcademicSelection():Observable<any>{  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True', });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Master/GetAllAcademicSelection',{headers:reqHeader});
  }
}
